import BookingsPage from "@/features/user/components/bookings/bookings-page";
import { appTitleHead } from "@/lib/app-document-title";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/account/_auth/bookings")({
  head: () => appTitleHead("account-bookings-title"),
  component: BookingsPage
});
